export class RolePageActionHasPermissions {
    /**
     * roleId	roleName
        1	Agent
        2	OTISLineAdministrator
        3	Admin
        4	AvayaUser
        5	Avayasupervisor
        6	AvayaRemoteOtisExpert
        7	OTISLineRemortExpert
        8	OTISLineSupervisor
        */
    static readonly roles = [
        {
        'page_name': 'otisline_settings',
        'role_id':{
            "1":[
                'countryName', 'callTimeOut','enableCallDispo','mediaRegion','recordAudio','recordVideo','days','FromNumber;RedirectNumber','edit'
            ],
            "2":[
                'countryName', 'callTimeOut','enableCallDispo','mediaRegion','recordAudio','recordVideo','days','FromNumber;RedirectNumber','edit'
                ],
            "3":[
                'countryName', 'callTimeOut','enableCallDispo','mediaRegion','recordAudio','recordVideo','days','FromNumber;RedirectNumber','edit',
                'delete',
            ],
            "4":[
                'countryName', 'enableCallDispo','mediaRegion','recordAudio','recordVideo','days','FromNumber','RedirectNumber','edit',
                ],            
            "7":[
                'countryName', 'enableCallDispo','mediaRegion','recordAudio','recordVideo','days','edit',
            ],
            "8":[
                'countryName', 'enableCallDispo','mediaRegion','recordAudio','recordVideo','days','edit',
                ],
            }
        },
        {
            'page_name': 'topbar',
            'role_id':{
                "1":[
                    
                ],
                "2":[
                    
                    ],
                "3":[
                    'countryList'
                ],
                "4":[
                   
                    ],
                "5":[
                   
                ],
                "6":[
                    
                    ],
                "7":[
                   
                ],
                "8":[
                    
                    ],
                }
            }
    ]

    /**
     * roleId	roleName
        1	Agent
        2	OTISLineAdministrator
        3	Admin
        4	AvayaUser
        5	Avayasupervisor
        6	AvayaRemoteOtisExpert
        7	OTISLineRemortExpert
        8	OTISLineSupervisor
        */
       static roleAccessMenu(roleId:string, pageName:string) {
        let resultData =  RolePageActionHasPermissions.roles.filter((obj:any) => {
            return obj.page_name === pageName;
        }); 
        let resultValue = resultData[0].role_id;
        let finalValue;
        Object.keys(resultValue)
            .forEach((key, value) => {
                if(key === roleId){
                    finalValue =  Object.values(resultValue)[value];
                }
            });
        return finalValue;
    }
}